export interface Prompt {
  featureType: string;
  systemPrompt: string;
  userPrompt: string;
  version: string;
  createdAt: string;
}

export interface PromptDTO {
  featureType: string;
  systemPrompt: string;
  userPrompt: string;
}

export enum AiFeatureTypes {
  JOB_RECOMMENDATIONS = "Job recommendations",
  RESUME_SUMMARY = "Resume summary",
}
